'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tooltip/dist/decorators/getEffect.js
// module id = ./node_modules/react-tooltip/dist/decorators/getEffect.js
// module chunks = vendor